import { createActions } from 'redux-actions';
import { ActionTypes } from '../constants/index';

export const {
  getBusinessesRequest,
  getBusinessesSuccess,
  getBusinessesFailure,
  updateBusinessStatusRequest,
  updateBusinessStatusSuccess,
  updateBusinessStatusFailure,
  getBusinessMeRequest,
  getBusinessMeSuccess,
  getBusinessMeFailure,
  getBusinessRewardsRequest,
  getBusinessRewardsSuccess,
  getBusinessRewardsFailure,
  uploadBusinessRewardsRequest,
  uploadBusinessRewardsSuccess,
  uploadBusinessRewardsFailure,
  deleteBusinessRewardRequest,
  deleteBusinessRewardSuccess,
  deleteBusinessRewardFailure,
  getBusinessRedemptionsRequest,
  getBusinessRedemptionsSuccess,
  getBusinessRedemptionsFailure,
  getBusinessQrRequest,
  getBusinessQrSuccess,
  getBusinessQrFailure,
} = createActions({
  [ActionTypes.GET_BUSINESSES_REQUEST]: () => ({}),
  [ActionTypes.GET_BUSINESSES_SUCCESS]: data => data,
  [ActionTypes.GET_BUSINESSES_FAILURE]: () => ({}),

  [ActionTypes.UPDATE_BUSINESS_STATUS_REQUEST]: (id, status) => ({ id, status }),
  [ActionTypes.UPDATE_BUSINESS_STATUS_SUCCESS]: () => ({}),
  [ActionTypes.UPDATE_BUSINESS_STATUS_FAILURE]: () => ({}),

  [ActionTypes.GET_BUSINESS_ME_REQUEST]: () => ({}),
  [ActionTypes.GET_BUSINESS_ME_SUCCESS]: data => data,
  [ActionTypes.GET_BUSINESS_ME_FAILURE]: () => ({}),

  [ActionTypes.GET_BUSINESS_REWARDS_REQUEST]: () => ({}),
  [ActionTypes.GET_BUSINESS_REWARDS_SUCCESS]: data => data,
  [ActionTypes.GET_BUSINESS_REWARDS_FAILURE]: () => ({}),

  [ActionTypes.UPLOAD_BUSINESS_REWARDS_REQUEST]: file => ({ file }),
  [ActionTypes.UPLOAD_BUSINESS_REWARDS_SUCCESS]: data => data,
  [ActionTypes.UPLOAD_BUSINESS_REWARDS_FAILURE]: () => ({}),

  [ActionTypes.DELETE_BUSINESS_REWARD_REQUEST]: rewardId => ({ rewardId }),
  [ActionTypes.DELETE_BUSINESS_REWARD_SUCCESS]: rewardId => ({ rewardId }),
  [ActionTypes.DELETE_BUSINESS_REWARD_FAILURE]: () => ({}),

  [ActionTypes.GET_BUSINESS_REDEMPTIONS_REQUEST]: () => ({}),
  [ActionTypes.GET_BUSINESS_REDEMPTIONS_SUCCESS]: data => data,
  [ActionTypes.GET_BUSINESS_REDEMPTIONS_FAILURE]: () => ({}),

  [ActionTypes.GET_BUSINESS_QR_REQUEST]: businessId => ({ businessId }),
  [ActionTypes.GET_BUSINESS_QR_SUCCESS]: data => data,
  [ActionTypes.GET_BUSINESS_QR_FAILURE]: () => ({}),
});
